import { protectedResources } from "../config/authConfig";
import { Organization } from "../types/organization";
import { _fetch, getToken } from "./apiHelper";

export const getOrganizations = async (): Promise<Organization[]> => {
  const accessToken = await getToken();

  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  headers.append("Content-Type", "application/json");

  const options = {
    method: "GET",
    headers: headers,
    cache: "no-cache" as RequestCache,
  };

  return _fetch(protectedResources.api.organization, options);
};
